module.exports = __webpack_public_path__ + "static/media/battles-background-splash.f6a16104.png";